import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick", "dataTestId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import useAppContext from '../../hooks/useAppContext';
import Icon from '../../components/ui-components/Icon';
import IconButton from 'flow/components/ui-components/IconButton';
import { jsx as _jsx } from "react/jsx-runtime";
var BackButton = function BackButton(_ref) {
  var onClick = _ref.onClick,
    dataTestId = _ref.dataTestId,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useAppContext = useAppContext(),
    i18next = _useAppContext.i18next;
  return /*#__PURE__*/_jsx(IconButton, _objectSpread(_objectSpread({
    tooltipLabel: i18next.t('Tooltip.Nav.Title.Back'),
    onClick: onClick,
    "data-test-id": dataTestId
  }, props), {}, {
    children: /*#__PURE__*/_jsx(Icon, {
      iconKey: "arrow_back",
      className: "rtl:scale-x-[-1]"
    })
  }));
};
export default BackButton;